import InformationTile from './InformationTile';

export default InformationTile;
